export const getSortableDate = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    const timestamp = value.getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  const normalizedValue = String(value).trim();
  const dateParts = normalizedValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dateParts) {
    return Date.UTC(
      Number(dateParts[1]),
      Number(dateParts[2]) - 1,
      Number(dateParts[3])
    );
  }

  const timestamp = new Date(normalizedValue).getTime();
  return Number.isNaN(timestamp) ? null : timestamp;
};

export const parseSortableCurrency = (value) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }

  const parsedValue = parseFloat(String(value ?? "").replace(/[$,]/g, ""));
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

export const sortTableRows = (rows, columns, sortConfig) => {
  if (!sortConfig?.key) {
    return rows;
  }

  const column = columns.find(({ key }) => key === sortConfig.key);
  if (!column) {
    return rows;
  }

  const getValue = (row) => {
    const rawValue = column.getValue
      ? column.getValue(row)
      : row[column.key];

    if (column.type === "currency" || column.type === "number") {
      return parseSortableCurrency(rawValue);
    }

    if (column.type === "date") {
      return getSortableDate(rawValue);
    }

    return rawValue === null || rawValue === undefined
      ? null
      : String(rawValue).trim();
  };

  return rows
    .map((row, originalIndex) => ({ row, originalIndex }))
    .sort((left, right) => {
      const leftValue = getValue(left.row);
      const rightValue = getValue(right.row);
      const leftIsBlank = leftValue === null || leftValue === "";
      const rightIsBlank = rightValue === null || rightValue === "";

      if (leftIsBlank && rightIsBlank) {
        return left.originalIndex - right.originalIndex;
      }
      if (leftIsBlank) return 1;
      if (rightIsBlank) return -1;

      const comparison = column.type === "date" ||
        column.type === "currency" ||
        column.type === "number"
        ? leftValue - rightValue
        : leftValue.localeCompare(rightValue, undefined, {
            numeric: true,
            sensitivity: "base",
          });

      if (comparison === 0) {
        return left.originalIndex - right.originalIndex;
      }

      return sortConfig.direction === "ascending"
        ? comparison
        : -comparison;
    })
    .map(({ row }) => row);
};

export const getNextSortConfig = (currentSort, key) => ({
  key,
  direction:
    currentSort.key === key && currentSort.direction === "ascending"
      ? "descending"
      : "ascending",
});

